import React, { ReactNode } from "react";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  width?: number;
  height?: number;
}

const ModalPopup: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  width = 960,
  height = "auto",
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div
        className="fixed inset-0 bg-black opacity-50"
        onClick={onClose}></div>
      <div
        className="bg-main-bg rounded-xl overflow-auto relative z-10"
        style={{ width: `${width}px`, height: `${height}px` }}>
        <button className="absolute top-4 right-4 text-white" onClick={onClose}>
          <img src="/assets/images/icon-close.svg" alt="Close" />
        </button>
        {children}
      </div>
    </div>
  );
};

export default ModalPopup;
